import Vue from 'vue';
import throttle from 'lodash/throttle';
import Municipality from '../services/municipality';

new Vue({
	el: '#municipalitySearch',
	data: () => ({
		suggestedMunicipalities: [],
		searchValue: '',
		hasFocus: false,
	}),
	methods: {
		doSearch: throttle(async function ({ target }) {
			const searchQuery = target.value;

			if (searchQuery === '') return;

			const municipalities = await Municipality.search(searchQuery);

			console.log(municipalities);

			this.suggestedMunicipalities = municipalities;
		}, 500),
		esc({ target }) {
			target.blur();
		},
		focusin() {
			this.hasFocus = true;
		},
		focusout() {
			this.hasFocus = false;
		},
	},
});



// WEBPACK FOOTER //
// ./assets/js/search/index.js